import React from 'react';
import PropTypes from 'prop-types';
import assets from "../../../../../util/assets";
import "./index.css";


Chips.propTypes = {
    text: PropTypes.string.isRequired,
    hideCross: PropTypes.bool,
    action: PropTypes.func.isRequired,
};

Chips.defaultProps = {
    hideCross: false
}

function Chips(props) {
    if (props.hideCross) {
        return (
            <span className="home-chips">
                <span onClick={props.action}>{props.text}</span>
            </span>
        );
    } else {
        return (
            <span className="home-chips">
                <span>{props.text}</span>
                <img src={assets.clipstore.chip_cross}
                     alt="cross"
                     onClick={props.action}
                />
            </span>
        );
    }
}

export default Chips;